<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card v-if="data">
            <v-card-title style="background-color: #009688; color: white;">
                Remove Member
            </v-card-title>
            <v-card-text style="padding-top: 20px; color: black;">
                Do you really want to remove this member?
                <v-simple-table style="margin-top: 20px;">
                    <template #default>
                        <tr>
                            <td>Account Name</td>
                            <td>{{ data.ACCT_N }}</td>
                        </tr>
                        <tr>
                            <td>Member Number</td>
                            <td>{{ data.MEMB_N }}</td>
                        </tr>
                        <tr>
                            <td>Member Name</td>
                            <td>{{ data.LAST_M }}</td>
                        </tr>
                        <tr>
                            <td>Added On</td>
                            <td>{{ formatDateToPst(data.ADDED_ON) }}</td>
                        </tr>
                        <tr>
                            <td>Added By</td>
                            <td>{{ data.ADDED_BY }}</td>
                        </tr>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="teal darken-1"
                    outlined
                    :disabled="loading"
                    @click="showDialog = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>
                    no
                </v-btn>
                <v-btn
                    color="teal darken-1 white--text"
                    :loading="loading"
                    @click="handleRemoveMember"
                >
                    <v-icon>{{ mdiCheck }}</v-icon>
                    yes
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { moment } from '../../../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'

export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiClose,
        mdiCheck,
        loading: false
    }),
    computed: {
        ...mapGetters(['removeMemberFromScopedBenefitData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        removeMemberFromScopedBenefitData(newVal) {
            if (newVal.status === 200) {
                this.notif.type = 'success'
                this.notif.color = 'success'
                this.notif.timeout = 5000
                this.notif.msg = 'Member has been removed successfully'
                this.notif.show = true
                this.handleFetchMembersOfScopedBenefit()
                this.showDialog = false
            } else {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
            }
            this.loading = false
        }
    },
    methods: {
        ...mapActions(['removeMemberFromScopedBenefit', 'fetchMembersOfScopedBenefit']),
        handleFetchMembersOfScopedBenefit() {
            const params = { BENEFIT_ID: this.data.BENEFIT_ID, ACCT_N: this.data.ACCT_N }
            this.fetchMembersOfScopedBenefit(params)
            this.$emit('handleLoadingFetchMembersOfScopedBenefit')
        },
        handleRemoveMember() {
            this.loading = true
            const params = { BENEFIT_ID: this.data.BENEFIT_ID, ACCT_N: this.data.ACCT_N, MEMB_N: this.data.MEMB_N }
            this.removeMemberFromScopedBenefit(params)
        },
        formatDateToPst(date) {
            if (date) {
                return moment(date).utcOffset('+0800').format('MMMM DD, YYYY')
            } else {
                return '-'
            }
        }
    }
}
</script>
